import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PageLayout from '../components/common/PageLayout';
import courseData from '../data/course.json';
import salesforceDevImage from '../images/copado-course.png';
import salesforceAiImage from '../images/salesforce-ai.png';
import salesforceLogo from '../images/salesforce-logo.png';
import './CategoryPage.css';

const CategoryPage = () => {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const offerings = courseData.offerings || [];
  const category = offerings.find((o) => o.id === categoryId);
  const courses = courseData.courses || {};

  if (!category || category.type !== 'category' || !category.subCategories?.length) {
    return (
      <PageLayout>
        <section className="page-hero">
          <h1>Category not found</h1>
          <p>This offering may have been moved or does not exist.</p>
        </section>
      </PageLayout>
    );
  }

  const subCategories = category.subCategories;

  const heroLogoSrc =
    category.id === 'salesforce'
      ? salesforceLogo
      : category.heroLogoUrl;

  const handleOpenCourse = (slug) => navigate(`/course/${slug}`);

  return (
    <PageLayout>
      <section className="page-hero category-hero">
        {heroLogoSrc && (
          <div className="category-hero-logo">
            <img src={heroLogoSrc} alt="" aria-hidden="true" loading="lazy" />
          </div>
        )}
        <h1>{category.title}</h1>
        <p>{category.description}</p>
      </section>
      <section className="category-section">
        <div className="category-cards-grid">
          {subCategories.map((sub) => {
            const course = courses[sub.courseSlug];
            const duration = course?.stats?.duration ?? '—';
            const level = course?.stats?.level ?? '—';
            const summary = course?.summary ?? '';
            const imageUrl =
              sub.courseSlug === 'salesforce-devops-copado-agentia' || sub.id === 'devops'
                ? salesforceDevImage
                : sub.courseSlug === 'salesforce-ai-developer' || sub.id === 'developer'
                  ? salesforceAiImage
                  : sub.courseSlug === 'salesforce-developer' || sub.id === 'admin'
                    ? salesforceDevImage
                    : (course?.imageUrl || category.imageUrl || '');

            return (
              <article key={sub.id} className="category-card">
                <div className="category-card-image-wrap">
                  <img src={imageUrl} alt="" loading="lazy" />
                </div>
                <div className="category-card-body">
                  <h2 className="category-card-title">{sub.title}</h2>
                  {summary && (
                    <p className="category-card-summary">{summary}</p>
                  )}
                  <p className="category-card-meta">{duration} · {level}</p>
                  <button
                    type="button"
                    className="category-card-cta"
                    onClick={() => handleOpenCourse(sub.courseSlug)}
                  >
                    View course
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </PageLayout>
  );
};

export default CategoryPage;
